import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from '../Header';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Control, LocalForm } from 'react-redux-form';
import { Helmet } from 'react-helmet';
import Footer from '../Footer';
import UserTable from './table';
import ModalExample from "./popup";
import ModalExample2 from "../../elements/PopupWindow";
import {config} from "../../../utility/swaggerClient";

const messages = defineMessages({
    htmlHeader: {
      id: 'preview.html.header',
      description:
        'The title of the page that appears in the html header of the page.',
      defaultMessage: 'Preview'
    },
    headerTitle: {
      id: 'project.management.html.header',
      description: 'Page Header Title',
      defaultMessage: 'Dashboard'
    },
    headerSubTitle: {
      id: 'project.management.subtitle',
      description: 'Page Header Subtitle',
      defaultMessage: 'Project Management Subtitle'
    },
    searchFiles: {
      id: 'preview.search.files',
      description: 'search files',
      defaultMessage: 'Search Files'
    },
    alertTitle: {
      id: 'preview.alert.title',
      description: 'Preview API alert title',
      defaultMessage: 'Loading Project Files Failed'
    }
  });

class NPUserView extends Component {
  constructor(props) {
    super(props);
    const { intl } = this.props;
  }
  render() {
        return (
          <div className="preview page">
            <Header
              title={this.props.intl.formatMessage(messages.headerTitle)}
              subtitle={this.props.intl.formatMessage(messages.headerSubTitle)}
              icon="preview"
              locale={this.props.locale}
              status = {this.props.status}
            />
          </div>
          )
    }
}

export default NPUserView;


// WEBPACK FOOTER //
// ./src/components/views/ProjectManagement/NPUserView.jsx